// noinspection JSUnresolvedVariable
export const BRC_RECOVER_TYPE = BRC_RECOVER_FLOW_TYPE;  // from js_strings
// noinspection JSUnresolvedVariable
export const REPLIBIT_RECOVER_TYPE = REPLIBIT_RECOVER_FLOW_TYPE; // from js_strings

// BRC/RB/D2C
export const DEFAULT_RECOVER_FLOW_NAME = 'recovery';

export const AJAX_DATA_TYPE_JSON = 'json';
